export const TALK_IT_OUT_UNSUPPORTED_MESSAGE = "Talk it Out is not available in this browser. Type or paste instead.";

export function appendDictationTranscript(existing: string, transcript: string): string {
  const next = transcript.replace(/\s+/g, " ").trim();
  if (!next) return existing;
  const current = existing.trimEnd();
  if (!current) return next;
  return `${current} ${next}`;
}

export function dictationErrorMessage(error: string): string | null {
  if (error === "aborted" || error === "no-speech") return null;
  if (error === "not-allowed" || error === "service-not-allowed") {
    return "Microphone access is required for Talk it Out.";
  }
  return "Talk it Out could not capture audio. You can still type or paste.";
}
